import { render, staticRenderFns } from "./MedicamentConfigureDrawer.vue?vue&type=template&id=2b0ae9f0&scoped=true&"
import script from "./MedicamentConfigureDrawer.vue?vue&type=script&lang=js&"
export * from "./MedicamentConfigureDrawer.vue?vue&type=script&lang=js&"
import style0 from "./MedicamentConfigureDrawer.vue?vue&type=style&index=0&id=2b0ae9f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0ae9f0",
  null
  
)

export default component.exports